import { ReactNode } from "react";

interface PasswordFieldProps {
  name: string;
  defaultValue?: string;
  placeholder?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

const PasswordField: React.FunctionComponent<PasswordFieldProps> = ({
  name,
  defaultValue,
  icon,
  disabled,
  placeholder
}) => {
  
  return (
    <div className="relative">
      {icon && (
        <div className={"input-icon" + (disabled ? " disabled" : "")}>
          {icon}
        </div>
      )}

      <input
        type="password"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        className="input-field"
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default PasswordField;